import { Component, OnInit, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import { FreshdeskWidgetService } from "@app/shared/service/freshdesk-widget.service";
import { MasterService } from "@app/shared/service/master.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute } from "@angular/router";
import { interval, Subscription } from "rxjs";
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import { FormControl, FormGroup, Validators } from "@angular/forms";
@Component({
  selector: "app-sso-data-collect",
  templateUrl: "./sso-data-collect.component.html",
  styleUrls: ["./sso-data-collect.component.sass"],
})
export class SSODataCollectComponent implements OnInit {
  year: string;
  loading: boolean = true;
  uuid = "";
  ssoData: any = {};
  phoneNo: string = "";
  phoneNoError: boolean = false;
  error: boolean = false;
  countryList: { countryCode: string, callingCode: string }[] = [];
  countryCodes: { [key: string]: string } = {};
  selectedCountryCode: string = 'CA';
  selectedCallingCode: string = '1';
  timer: string = "60";
  timerSubscription: Subscription;
  signupForm: FormGroup;

  sentOtp: boolean = false;
  resentOtp: boolean = false;
  noEdit: boolean = true;

  constructor(
    private MasterService: MasterService,
    private activatedRoute: ActivatedRoute,
    public toasterService: ToastrService,
    private router: Router,
    private freshdeskWidgetService: FreshdeskWidgetService,
  ) {
    let date = new Date();
    this.year = date.getFullYear().toString();
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      console.log("Path Param");
      console.log(params);
      this.uuid = params.uuid;
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      console.log("Query Param");
      console.log(params);
    });
    this.getData();
    this.freshdeskWidgetService.hideWidget();
    this.loadCountryCallingCodes();
  }

  loadCountryCallingCodes() {
     const countries = getCountries();
    countries.forEach(country => {
      const callingCode = getCountryCallingCode(country);
      this.countryList.push({ countryCode: country, callingCode });
      this.countryCodes[country] = callingCode;
    });
  }


  onCountryChange() {
    this.selectedCallingCode = this.countryCodes[this.selectedCountryCode];
    console.log(`Calling Code: +${this.selectedCallingCode}`);
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.freshdeskWidgetService.showWidget();
  }

  slideConfig2 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    slidesToShow: 1,
    speed: 500,
    dots: true,
    autoplay: true,
  };

  getData(): void {
    console.log("getdata");
    this.loading = true;
    this.error = false;
    this.MasterService.getSSODataToken(this.uuid).subscribe(
        (res) => {
          this.loading = false;
          this.ssoData = res;
          console.log(this.ssoData);
          this.intializeForm();
        },
        (err) => {
          console.log("Some error occured" + JSON.stringify(err));
          this.toasterService.error(this.MasterService.getError(err), "Error", { positionClass: "toast-top-right" });
          this.loading = false;
          this.error = true;
        },
      );
  }

  intializeForm() {
    console.log("intialize");
    console.log("signupForm", this.signupForm);
    this.signupForm = new FormGroup({
      phoneNo: new FormControl(null, [Validators.required]),
      email: new FormControl(this.ssoData.email),
      otp: new FormControl(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    });
    console.log("this", this);
  }
  login(): void {
    if (this.signupForm.valid) {
      let temp: any = this.signupForm.getRawValue();
      

      this.loading = true;
      
      let phoneNo = this.signupForm.get("phoneNo").value;
      temp.phoneNo = `+${this.selectedCallingCode} ${phoneNo}`;

      console.log("temp" + JSON.stringify(temp));
      this.MasterService.saveSSOData(this.uuid, temp).subscribe(
        (res) => {
          this.loading = false;
          console.log("Login Validation Staart");
          localStorage.setItem("bearer", res.accessToken);
          this.MasterService.getUser().subscribe((res) => {
            console.log("userInfo" + JSON.stringify(res.lrsUser));
            localStorage.setItem("user", JSON.stringify(res.lrsUser));
            localStorage.setItem("name", JSON.stringify(res.userName));
            if (res) {
              let url = "customer/dashboard";
              this.loading = false;
              this.router.navigateByUrl("app/pages/" + url);
            }
          });
          console.log("Login Validation end");
          //this.router.navigateByUrl("");
        },
        (err) => {
          console.log("Some error occured" + JSON.stringify(err));
          this.toasterService.error(this.MasterService.getError(err), "Error", { positionClass: "toast-top-right" });
          this.loading = false;
        },
      );
    } else {
      this.signupForm.markAllAsTouched();
    }
  }
  checkDefault() {
    let phoneNo = this.signupForm.get("phoneNo").value;
    if (!phoneNo || phoneNo.length == 0) {
      phoneNo = "+91 ";
      this.signupForm.get("phoneNo").setValue(phoneNo);
    }
  }

  startTimer(): void {
    this.timerSubscription = interval(1000).subscribe(() => {
      if (+this.timer > 0) {
        this.timer = (+this.timer - 1).toString();
        if (+this.timer < 10) {
          this.timer = "0" + this.timer;
        }
      } else {
        this.timerSubscription.unsubscribe();
        if (this.sentOtp) this.resentOtp = true;
      }
    });
  }

  sendOtp(): void {
    console.log(this.signupForm.get("phoneNo"));

    if (!this.signupForm.get("phoneNo").errors) {
      console.log("OTP Sent");
      this.loading = true;
      let temp: any = {};
      let phoneNo = this.signupForm.get("phoneNo").value;
      temp.phoneNo = `+${this.selectedCallingCode} ${phoneNo}`;
      this.MasterService.ssoSignUpOTP(temp).subscribe(
        (res) => {
          this.toasterService.success(res?.msg, "Success", { positionClass: "toast-top-right" });
          this.timer = "60";
          this.resentOtp = false;
          this.sentOtp = true;
          this.noEdit = false;
          this.startTimer();
          this.loading = false;
        },
        (err) => {
          console.log("Some error occured" + JSON.stringify(err));
          this.toasterService.error(this.MasterService.getError(err), "Error", { positionClass: "toast-top-right" });
          this.loading = false;
        },
      );
    }
  }
  editNo() {
    this.timerSubscription.unsubscribe();
    this.resentOtp = false;
    this.sentOtp = false;
    this.noEdit = true;
  }
}
